export class ContactFormModel {
    name: string;
    email: string;
    message: string;
    recaptcha: string;
    userAgent: boolean;

    constructor(contact?) {
        contact = contact || {};
        this.name = contact.name || '';
        this.email = contact.email || '';
        this.message = contact.message || '';
        this.recaptcha = contact.recaptcha || '';
        this.userAgent = contact.userAgent || 1;
    }
}